import React, { useState, useEffect } from 'react';
import './Hero.css';
import { addToWaitlist } from '../../firebase/waitlistService';
import { FireSimple } from '@phosphor-icons/react';

function Hero() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Trigger animations on mount
    setIsLoaded(true);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setMessage('Please enter a valid email address');
      setIsSuccess(false);
      return;
    }

    setIsLoading(true);
    setMessage('');

    try {
      const docId = await addToWaitlist(email);
      console.log('Successfully added to waitlist with ID:', docId);
      setMessage('Successfully joined the waitlist! We\'ll be in touch soon.');
      setIsSuccess(true);
      setEmail(''); // Clear the form
    } catch (error) {
      console.error('Error adding to waitlist:', error);
      setMessage('Sorry, there was an error joining the waitlist. Please try again.');
      setIsSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="hero" id="hero">
      <div className="hero-top">
        <div className="hero-solana-banner">
          <span>Powered by</span>
          <img src="https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fsolana%20france.png?alt=media&token=b8d3521d-fcda-43ae-a365-df31796fdfc5" alt="Powered by Solana" />
        </div>
        <h1 className={`hero-title ${isLoaded ? 'hero-content-visible' : ''}`}>
          The Social Layer for Group Finance
        </h1>
      </div>
      <div className={`hero-image ${isLoaded ? 'hero-image-visible' : ''}`}>
        <img src="https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fhero-img.png?alt=media&token=ab2a101a-d96e-4782-940f-ce30b93cabf4" alt="WeSplit App Interface" />
      </div>
      <div className="hero-gradient-overlay"></div>
    </section>
  );
}

export default Hero;
